import React from "react";

import Table from "../../common/Table";

import lbl from "../../../data/Labels.json";

const AttendanceList = ({ activeSem }) => {
  const renderResult = (e) =>{
    let disqualified = e.attendance_result === 'disqualified';
    return (
      <div className={`result-result-${disqualified ? 3 : 1}`}>
        {disqualified ? 'محروم' : 'شامل امتحان'}
      </div>
    )
  }

  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "subject_name", label: "مضمون", content: (e) => <b>{e.subject_name}</b> },
    { path: "credits", label: "تعداد کردت" },
    { path: "present_count", label: "حاضر", content: (e) => <div>{e.present_count} ({e.present_percentage}%)</div> },
    { path: "absent_count", label: "غیر حاضر", content: (e) => <div>{e.absent_count} ({e.absent_percentage}%)</div> },
    { path: "result", label: "نتیجه" , content: (e) => renderResult(e)},
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.ListOfSubjects}</p>
      <Table
        data={activeSem?.subjects}
        columns={paymentsColumn}
      />
    </div>
  );
};

export default AttendanceList;
